export const LogoErrorEmail = () => {
  return (
    <svg
      width="368"
      height="272"
      viewBox="0 0 368 272"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M103.536 63C95.0986 63 88.5361 70.0312 88.5361 78V96.75L179.942 164.25C187.911 169.875 198.692 169.875 206.661 164.25L298.536 96.75V78C298.536 70.0312 291.505 63 283.536 63H103.536ZM88.5361 115.5V198C88.5361 206.438 95.0986 213 103.536 213H283.536C291.505 213 298.536 206.438 298.536 198V115.5L215.567 176.438C202.442 185.812 184.161 185.812 171.036 176.438L88.5361 115.5ZM73.5361 78C73.5361 61.5938 86.6611 48 103.536 48H283.536C299.942 48 313.536 61.5938 313.536 78V198C313.536 214.875 299.942 228 283.536 228H103.536C86.6611 228 73.5361 214.875 73.5361 198V78Z"
        fill="#FF6363"
      />
      <path
        d="M35.837 13.945L350.767 233.036C357.794 237.925 359.528 247.585 354.639 254.612C349.751 261.639 340.091 263.373 333.064 258.484L18.1335 39.3928C11.1063 34.5041 9.37272 24.8443 14.2614 17.8172C19.1501 10.79 28.8098 9.05636 35.837 13.945Z"
        fill="#FF6363"
        stroke="#330000"
        strokeWidth="21"
      />
    </svg>
  );
};
